import * as React from "react";
const arFloat = (ar) => {
    switch (ar) {
        case "Square":
            return 1;
        case "FourByThree":
            return 4 / 3;
        case "SixteenByNine":
            return 16 / 9;
    }
};
const getMaxDimensions = (crop, arFloat) => {
    if (arFloat < 1) {
        // tall crop
        const w = Math.min(crop.height * arFloat, crop.width);
        const h = w / arFloat;
        return [w, h];
    }
    else {
        // wide or square crop
        const h = Math.min(crop.width / arFloat, crop.height);
        const w = h * arFloat;
        return [w, h];
    }
};
const getMaxRect = (crop, aspectRatio) => {
    const ar = arFloat(aspectRatio);
    const [w, h] = getMaxDimensions(crop, ar);
    const centerX = (crop.x + crop.width) / 2;
    const x = centerX - w / 2;
    const centerY = crop.y + crop.height / 2;
    const y = centerY - h / 2;
    return { w, h, x, y };
};
const rectToQueryParamValue = (rect) => {
    let { x, y, w, h } = rect;
    return `${Math.round(x)},${Math.round(y)},${Math.round(w)},${Math.round(h)}`;
};
const queryString = (query) => {
    if (query.type === "MinWidth") {
        return `(min-width: ${query.minWidth}px)`;
    }
    else if (query.type === "MaxWidth") {
        return `(max-width: ${query.maxWidth}px)`;
    }
};
const getImgixUrl = (crop, aspectRatio, blur, width, environment = "staging", forceCrop = false) => {
    const { url } = crop;
    const rect = forceCrop ?
        rectToQueryParamValue({ x: crop.x, y: crop.y, w: crop.width, h: crop.height }) :
        rectToQueryParamValue(getMaxRect(crop, aspectRatio));
    return `https://hoopla.imgix.net/${environment}/${encodeURIComponent(url)}?auto=format,compress&rect=${rect}&width=${Math.round(width)}&blur=${Math.round(blur)}`;
};
const getSrcSet = (crop, aspectRatio, blur, width, environment = "staging", forceCrop = false) => {
    const url = getImgixUrl(crop, aspectRatio, blur, width, environment, forceCrop);
    return `${url}&dpr=1 1x, ${url}&dpr=2 2x, ${url}&dpr=3 3x`;
};
const Image = React.forwardRef((props, ref) => {
    return (React.createElement("picture", null,
        props.queries.map((query) => (React.createElement("source", { key: queryString(query), media: queryString(query), srcSet: getSrcSet(query.crop, query.size.ar, props.blur ?? 0, query.size.width, props.environment, props.forceCrop) }))),
        React.createElement("img", { onLoad: props.onLoad, className: props.className, style: props.style, ref: ref, alt: props.alt, src: getImgixUrl(props.crop, props.default.ar, props.blur ?? 0, props.default.width, props.environment, props.forceCrop) })));
});
export default Image;
//# sourceMappingURL=Image.js.map